import Vue from "vue"
import VueRouter from "vue-router"
import Home from "../views/Home.vue"
import { cityDetail } from "../util/mainOption"
import { mainReqUrl } from "../util/mainReqUrl"
// 获取原型对象push函数
const originalPush = VueRouter.prototype.push

// 获取原型对象replace函数
const originalReplace = VueRouter.prototype.replace

// 修改原型对象中的push函数
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

// 修改原型对象中的replace函数
VueRouter.prototype.replace = function replace (location) {
  return originalReplace.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: "首页",
    component: Home,
    meta: {
      keepAlive: true,
      isShowHeader: true,
      isshowjjxm: true
    }
  },
  {
    path: "/register",
    name: "注册",
    // component: () => cityDetail.cityName == "许昌市" ? import("../views/register_无验证码版本.vue") : import("../views/register_验证码版本.vue"),
    component: () => import("../views/register_验证码版本.vue"),
    meta: {
      keepAlive: true,
      noShowHeader: true
    }
  },
  {
    path: "/login",
    name: "登录",
    component: () => import("../views/login.vue"),
    meta: {
      keepAlive: true,
      noShowHeader: true
    }
  },
  {
    path: "/xinyangBigData",
    name: "交易大数据",
    // component: () => import("../views/xinyangBigData_静态页面.vue"),
    // component: () => import("../views/xinyangBigData_动态页面.vue"),
    // component: () => import("../views/xinyangBigData_动态页面_跳转地市.vue"),
    component: () => import("../views/xinyangBigData_动态页面_不下钻.vue"),

    meta: {
      keepAlive: true,
      noShowHeader: true,
      nozoom: true
    }
  },
  {
    path: "/personal",
    name: "个人中心",
    component: () => import("../views/个人中心.vue"),
    meta: {
      keepAlive: false
    }
  },
  {
    path: "/towns",
    name: "乡镇",
    component: () => import("../views/Towns.vue"),
    meta: {
      keepAlive: false,
      isShowHeader: true,
      isshowjjxm: false
    }
  },
  {
    path: "/propertyAttract",
    name: "资产招商",
    component: () => import("../views/资产招商.vue"),
    meta: {
      keepAlive: false
      // isShowPressCenterDetailHeader: true
    }
  },
  {
    path: "/propertyAttractdetail",
    name: "资产招商详情",
    component: () => import("../views/资产招商详情.vue"),
    meta: {
      keepAlive: false
      // isShowPressCenterDetailHeader: true
    }
  },
  {
    path: "/pressCenter",
    name: "新闻中心",
    component: () => import("../views/新闻中心.vue"),
    meta: {
      keepAlive: false
      // isShowPressCenterDetailHeader: true
    }
  },
  {
    path: "/pressCenter/pressCenterDetail",
    name: "新闻中心详情",
    component: () => import("../views/新闻中心详情.vue"),
    meta: {
      keepAlive: false
    }
  },
  {
    path: "/tradingProject",
    name: "交易项目",
    component: () => import("../views/交易项目.vue"),
    meta: {
      keepAlive: false
      // isShowPressCenterDetailHeader: true
    }
  },
  {
    path: "/tradingProject/pressCenterDetail",
    name: "交易项目详情",
    component: cityDetail.freeBidding && cityDetail.startWebSocket && mainReqUrl.socketUrl ?
      () => import("../views/交易项目详情_自由竞价版本_socket.vue") :
      cityDetail.startWebSocket && mainReqUrl.socketUrl ?
        () => import("../views/交易项目详情_阶梯竞价版本.vue") :
        () => import("../views/交易项目详情_阶梯竞价版本_无socket.vue"),
    meta: {
      keepAlive: false
      // isShowPressCenterDetailHeader: true
    }
  },
  {
    path: "/tradingProject/pressCenterDetail1",
    name: "招投标项目详情",
    component: () => import("../views/招投标项目详情_老版本.vue"),
    meta: {
      keepAlive: false
    }
  },
  {
    path: "/chengjiaogonggao",
    name: "成交公告",
    component: () => import("../views/成交公告.vue"),
    meta: {
      keepAlive: false
    }
  },
  {
    path: "/chengjiaogonggao/detail",
    name: "成交公告详情",
    component: () => import("../views/成交公告详情.vue"),
    meta: {
      keepAlive: false
    }
  },
  {
    path: "/bangzhuzhongxin/detail",
    name: "帮助中心详情",
    component: () => import("../views/帮助中心详情.vue"),
    meta: {
      keepAlive: false
    }
  },
  {
    path: "/jianzhenggonggao/detail",
    name: "鉴证公告详情",
    component: () => import("../views/鉴证公告详情.vue"),
    meta: {
      keepAlive: false
    }
  },
  {
    path: "/jingjiaxiangmu",
    name: "竞价项目",
    component: () => import("../views/竞价项目.vue"),
    meta: {
      keepAlive: false
    }
  },
  {
    path: "/tradingGuide",
    name: "交易指南",
    component: () => import("../views/交易指南.vue"),
    meta: {
      keepAlive: false
      // isShowPressCenterDetailHeader: true
    }
  },
  {
    path: "/tradingGuide/detail",
    name: "交易指南详情",
    component: () => import("../views/交易指南详情.vue"),
    meta: {
      keepAlive: false
    }
  },
  {
    path: "/policiesRegulations",
    name: "政策法规",
    component: () => import("../views/政策法规.vue"),
    meta: {
      keepAlive: false
      // isShowPressCenterDetailHeader: true
    }
  },
  {
    path: "/policiesRegulations/detail",
    name: "政策法规详情",
    component: () => import("../views/政策法规详情.vue"),
    meta: {
      keepAlive: false
    }
  },
  {
    path: "/jianzhengshu",
    name: "鉴证书",
    component: () => import("../views/鉴证书.vue"),
    meta: {
      keepAlive: false
    }
  },
  {
    path: "/jianzhengshu/detail",
    name: "鉴证书详情",
    component: () => import("../views/鉴证书详情.vue"),
    meta: {
      keepAlive: false
    }
  },
  {
    path: "/dataDownload",
    name: "资料下载",
    component: () => import("../views/资料下载.vue"),
    meta: {
      keepAlive: false
      // isShowPressCenterDetailHeader: true
    }
  },
  {
    path: "/dataDownload/detail",
    name: "资料下载详情",
    component: () => import("../views/资料下载详情.vue"),
    meta: {
      keepAlive: false
    }
  },
  {
    path: "/dataSta",
    name: "数据统计",
    component: () => import("../views/数据统计.vue"),
    meta: {
      keepAlive: false
    }
  },
  {
    path: "/aboutUs",
    name: "关于我们",
    component: () => import("../views/关于我们.vue"),
    meta: {
      keepAlive: false
      // isShowPressCenterDetailHeader: true
    }
  },
  {
    path: "/aboutUs/complaints",
    name: "投诉与回复",
    component: () => import("../views/投诉与回复.vue"),
    meta: {
      keepAlive: false
    }
  },
  {
    path: "/aboutUs/select",
    name: "项目政策法规查询",
    component: () => import("../views/项目政策法规查询.vue"),
    meta: {
      keepAlive: false
    }
  },
  {
    path: "/aboutUs/select1",
    name: "项目咨询",
    component: () => import("../views/项目咨询.vue"),
    meta: {
      keepAlive: false
    }
  },
  {
    path: "/financing",
    name: "融资公告",
    component: () => import("../views/融资公告.vue"),
    meta: {
      keepAlive: false
    }
  },
  {
    path: "/financialService",
    name: "金融服务",
    component: () => import("../views/金融服务.vue"),
    meta: {
      keepAlive: false
    }
  },
  {
    path: "/jrfwListXXS",
    name: "金融服务_银行列表_信阳市",
    component: () => import("../views/金融服务_银行列表_信阳市.vue"),
    meta: {
      keepAlive: false
    }
  },
  {
    path: "/jrfwListHJX",
    name: "金融服务_银行列表_获嘉县",
    component: () => import("../views/金融服务_银行列表_获嘉县.vue"),
    meta: {
      keepAlive: false
    }
  },
  {
    path: "/financing/detail",
    name: "融资公告详情",
    component: () => import("../views/融资公告详情.vue"),
    meta: {
      keepAlive: false
    }
  },
  {
    path: "/turnOut",
    name: "意向转让",
    component: () => import("../views/意向转让.vue"),
    meta: {
      keepAlive: false
    }
  },
  {
    path: "/registName",
    name: "产权报名",
    component: () => import("../views/产权报名.vue"),
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/announcement",
    name: "通知抵押公告",
    component: () => import("../views/通知抵押公告.vue"),
    meta: {
      keepAlive: false
    }
  },
  {
    path: "/announcement/detail",
    name: "通知抵押公告详情",
    component: () => import("../views/通知抵押公告详情.vue"),
    meta: {
      keepAlive: false
    }
  },
  {
    path: "/tudizixun",
    name: "土地咨询",
    component: () => import("../views/土地咨询.vue"),
    meta: {
      keepAlive: false
    }
  },
  {
    path: "/tudizixun/detail",
    name: "土地咨询详情",
    component: () => import("../views/土地咨询详情.vue"),
    meta: {
      keepAlive: false
    }
  },
  {
    path: "/gongshigonggao",
    name: "公示公告",
    component: () => import("../views/公示公告.vue"),
    meta: {
      keepAlive: false
    }
  },
  {
    path: "/gongshigonggao/detail",
    name: "公示公告详情",
    component: () => import("../views/公示公告详情.vue"),
    meta: {
      keepAlive: false
    }
  },
  {
    path: "/tudixinxi",
    name: "土地信息",
    component: () => import("../views/土地信息.vue"),
    meta: {
      keepAlive: false
    }
  },
  {
    path: "/tudixinxi/detail",
    name: "土地信息详情",
    component: () => import("../views/土地信息详情.vue"),
    meta: {
      keepAlive: false
    }
  },
  {
    path: "/zhaoshangxiangmu",
    name: "招商项目",
    component: () => import("../views/招商项目.vue"),
    meta: {
      keepAlive: false
    }
  },
  {
    path: "/zhaoshangxiangmu/detail",
    name: "招商项目详情",
    component: () => import("../views/招商项目详情.vue"),
    meta: {
      keepAlive: false
    }
  },
  {
    path: "/zhuanchushourang",
    name: "意向转出受让",
    component: () => import("../views/意向转出受让.vue"),
    meta: {
      keepAlive: false
    }
  },
  {
    path: "/zhuanchushourang/detail",
    name: "意向转出受让详情",
    component: () => import("../views/意向转出受让详情.vue"),
    meta: {
      keepAlive: false
    }
  },
  {
    path: "/quanzhansousuo",
    name: "全站搜索",
    component: () => import("../views/全站搜索.vue"),
    meta: {
      keepAlive: false
    }
  },
  {
    path: "/quanzhansousuo/detail",
    name: "全站搜索详情",
    component: () => import("../views/全站搜索详情.vue"),
    meta: {
      keepAlive: false
    }
  },
  {
    path: "/bidDetail",
    name: "招投标详情",
    component: () => import("../views/招投标详情.vue"),
    meta: {
      keepAlive: false
    }
  },
  {
    path: "/demandDetail",
    name: "产权需求详情",
    component: cityDetail.freeBidding && cityDetail.startWebSocket && mainReqUrl.socketUrl ?
      () => import("../views/产权需求详情_自由竞价版本_socket.vue") :
      cityDetail.startWebSocket && mainReqUrl.socketUrl ?
        () => import("../views/产权需求详情_阶梯竞价版本.vue") :
        () => import("../views/产权需求详情_阶梯竞价版本_无socket.vue"),
    meta: {
      keepAlive: false
    }
  },
  {
    path: "/policy",
    name: "规章制度",
    component: () => import("../views/规章制度.vue"),
    meta: {
      keepAlive: false
    }
  },
]

const router = new VueRouter({
  // mode: 'history',
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
